/*
The note message component manages the cart's attributes values and fetching updates to the cart when the values change.
 */

import Component from "./../../component";

export const CartDrawerNoteMessageConfig = {
    signature: 'CartDrawerNoteMessage',
    baseHtmlClass: 'go-cart__drawer__note_message',
    selector: '.go-cart__drawer__note_message',

    initedHtmlClassModifier: 'inited',
    hasNoteHtmlClassModifier: 'has_note',

    headerElementSelector: '.cart__drawer__note_message__header',
    bodyElementSelector: '.cart__drawer__note_message__body',
    messageInputSelector: '[name="attributes[note-message]"]',
    hasNoteInputSelector: '[name="attributes[has-note]"]',

    hasNoteKey: 'has-note',
    noteMessageKey: 'note-message',

    messageInputExpandedRowsCount: 5,
};

export class CartDrawerNoteMessage extends Component {

    constructor(id_or_element, goCart) {
        super({
            element: id_or_element,
            config: CartDrawerNoteMessageConfig
        });

        this.goCart = goCart;

        this.noteManager = this.goCart?.noteManager;

        this.headerElement = this.element.querySelector(CartDrawerNoteMessageConfig.headerElementSelector);
        this.bodyElement = this.element.querySelector(CartDrawerNoteMessageConfig.bodyElementSelector);

        this.messageInput = this.element.querySelector(CartDrawerNoteMessageConfig.messageInputSelector);
        if (this.messageInput) {
            this.messageInput.addEventListener('change', this.handleMessageInputChange.bind(this));
            this.messageInput.addEventListener('focus', this.handleMessageInputFocus.bind(this));
            this.messageInput.addEventListener('blur', this.handleMessageInputBlur.bind(this));
        }

        this.hasNoteInput = this.element.querySelector(CartDrawerNoteMessageConfig.hasNoteInputSelector);

        this.initialMessageInputRows = (this.messageInput ? this.messageInput.getAttribute('rows') : 1);
        this.messageInputExpanded = !!this.hasMessageInputValue();

        this.inited = true;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, CartDrawerNoteMessageConfig.initedHtmlClassModifier);
        this.conditionallySetHtmlClassState(this.hasMessageInputValue(), CartDrawerNoteMessageConfig.hasNoteHtmlClassModifier);

        this.renderMessageInput();
        this.renderhasNoteInput();
    }

    renderMessageInput() {
        if (!this.messageInput) return;
        this.messageInput.setAttribute('rows', (!!this.messageInputExpanded ? CartDrawerNoteMessageConfig.messageInputExpandedRowsCount : this.initialMessageInputRows));
    }

    renderhasNoteInput() {
        if (!this.hasNoteInput) return;
        this.hasNoteInput.value = this.hasMessageInputValue();
    }

    handleMessageInputChange() {
        this.messageInputExpanded = !!this.hasMessageInputValue();
        this.render();
        this.updateCart().then(this.render.bind(this));
    }

    handleMessageInputFocus() {
        this.messageInputExpanded = true;
        this.render();
    }

    handleMessageInputBlur() {
        this.messageInputExpanded = !!this.hasMessageInputValue();
        this.render();
    }

    async updateCart() {
        await window.fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'include',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(await this.getSubmitData()),
        })
            .then((response) => response.json())
            .then((cartJson) => this.updateCartHandler(cartJson))
            .catch((error) => {
                throw new Error(error)
            });
    }

    updateCartHandler(cartJson) {
        // console.log('[CartDrawerNoteMessage] updateCartHandler() cartJson: ', cartJson);
    }

    getMessageInputValue() {
        if (!this.messageInput) return null;
        return this.messageInput.value;
    }

    hasMessageInputValue() {
        const value = this.getMessageInputValue();
        return (typeof value !== 'undefined') && (value !== null) && (value !== '');
    }

    async getSubmitData() {
        let data = {attributes: {}};
        data['attributes'][CartDrawerNoteMessageConfig.hasNoteKey] = this.hasMessageInputValue();
        data['attributes'][CartDrawerNoteMessageConfig.noteMessageKey] = this.getMessageInputValue();
        data['note'] =  await this.getNote();
        return data;
    }

    async getNote() {
        if (typeof this.noteManager === 'undefined' || typeof this.noteManager === 'null') return;
        await this.noteManager.setForKey(CartDrawerNoteMessageConfig.hasNoteKey, (this.hasMessageInputValue() ? true : null));
        return this.noteManager.get();
    }

}
